var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 25,
    rx: 3,
    fill: "#FFB5C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8081 6.80084L17.383 18.6544C17.3708 18.9942 17.0947 19.2742 16.7731 19.2742H9.41458C9.09222 19.2742 8.8169 18.9947 8.80469 18.6544L8.37955 6.80084C8.37236 6.60055 8.21222 6.44432 8.02185 6.45188C7.83149 6.45944 7.68299 6.62792 7.69018 6.82821L8.11533 18.6817C8.14151 19.4116 8.72103 20 9.41458 20H16.7731C17.4657 20 18.0462 19.4113 18.0723 18.6817L18.4975 6.82821C18.5047 6.62792 18.3562 6.45944 18.1658 6.45188C17.9754 6.44432 17.8153 6.60055 17.8081 6.80084Z",
    fill: "#690411"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8638 9.47582V17.7016C12.8638 17.902 13.0182 18.0645 13.2087 18.0645C13.3992 18.0645 13.5537 17.902 13.5537 17.7016V9.47582C13.5537 9.27539 13.3992 9.11291 13.2087 9.11291C13.0182 9.11291 12.8638 9.27539 12.8638 9.47582Z",
    fill: "#690411"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2195 9.48649L10.4494 17.7123C10.455 17.9126 10.6139 18.0703 10.8043 18.0644C10.9948 18.0585 11.1446 17.8913 11.139 17.691L10.909 9.46515C10.9034 9.26481 10.7445 9.10718 10.5541 9.11307C10.3637 9.11897 10.2139 9.28615 10.2195 9.48649Z",
    fill: "#690411"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2785 9.46515L15.0485 17.691C15.0429 17.8913 15.1927 18.0585 15.3831 18.0644C15.5736 18.0703 15.7325 17.9126 15.7381 17.7123L15.968 9.48649C15.9736 9.28615 15.8238 9.11897 15.6334 9.11307C15.443 9.10718 15.2841 9.26481 15.2785 9.46515Z",
    fill: "#690411"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34493 7.05643H18.8426C19.0331 7.05643 19.1875 6.89396 19.1875 6.69353C19.1875 6.4931 19.0331 6.33063 18.8426 6.33063H7.34493C7.15443 6.33063 7 6.4931 7 6.69353C7 6.89396 7.15443 7.05643 7.34493 7.05643Z",
    fill: "#690411"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1146 6.70736L11.3607 6.06002C11.4262 5.88769 11.6535 5.72581 11.8291 5.72581H14.3586C14.5354 5.72581 14.761 5.8865 14.827 6.06002L15.0731 6.70736L15.7136 6.4378L15.4675 5.79047C15.2968 5.34138 14.8175 5 14.3586 5H11.8291C11.3714 5 10.8905 5.34255 10.7202 5.79047L10.4741 6.4378L11.1146 6.70736Z",
    fill: "#690411"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.95d35ab24a396fba4f3d629503b0b5a2.svg";
export { ForwardRef as ReactComponent };